export class BrowserBuild {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    isProductionBuild = window.node_env === 'production';
    isDevelopmentBuild = !this.isProductionBuild;
}
